const {Component} = require("react");
const PropTypes = require("prop-types");
const {classList} = require("helpers/html");
const ModalContainerFabricator = require("components/modals/ModalContainer");

class BaseModal extends Component {

	static get propTypes() {
		return {
			getContainer: PropTypes.func,
			contentRef: PropTypes.func,
			defaultOpen: PropTypes.bool,
			handleOpen: PropTypes.func,
			handleClose: PropTypes.func,
			closeable: PropTypes.bool,
			className: PropTypes.string
		};
	}

	static get defaultProps() {
		return {
			defaultOpen: false,
			closeable: true
		};
	}

	constructor(props) {
		super(props);

		this.className = props.className;
		this.closeable = props.closeable;
	}

	componentWillReceiveProps(props) {
		this.className = props.className;
		this.closeable = props.closeable;
		this.container.forceUpdate();
	}

	get baseClassName() {
		return "modal";
	}

	get container() {
		return ModalContainerFabricator.container;
	}

	componentDidMount() {
		// get container
		const container = this.container;

		if (container == null) {
			return;
		}

		container.mount(this, () => {
			container.setActive(this, this.props.defaultOpen);
		});
	}

	componentWillUnmount() {
		// get container
		const container = this.container;

		if (container == null) {
			return;
		}

		container.unmount(this);
	}

	/////////////////////////////////
	// Hooks
	/////////////////////////////////

	onOpen = () => {
		if (typeof this.props.handleOpen === "function") {
			this.props.handleOpen();
		}
	};

	onClose = () => {
		if (typeof this.props.handleClose === "function") {
			this.props.handleClose();
		}
	};

	/////////////////////////////////
	// Methods
	/////////////////////////////////

	open() {
		this.container.open(this);
		return this;
	}

	close(force = false) {

		// Force closeable
		const closeable = this.closeable;
		if (force && !this.isCloseable()) {
			this.closeable = true;
		}

		this.container.close(this);

		// Undo closeable
		this.closeable = closeable;

		return this;
	}

	isActive() {
		return this.container.isActive(this);
	}

	isCloseable() {
		return this.closeable;
	}

	/////////////////////////////////
	// Renderers
	/////////////////////////////////

	renderHeader() {

	}

	renderBody() {
		return this.props.children;
	}

	renderFooter() {

	}

	renderContent(key, active) {
		const className = classList(
			this.baseClassName,
			active ? "active" : null,
			this.className
		);

		return (
			<div key={key} className={className}>
				{this.renderHeader()}
				<div className="modal-content">{this.renderBody()}</div>
				{this.renderFooter()}
			</div>
		);
	}

	render() {
		return (<React.Fragment></React.Fragment>);
		return (
			<div className="modal-ghost-node"></div>
		);
	}

}

module.exports = BaseModal;

